/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/no-children-prop */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState } from 'react';
import { View, TouchableOpacity } from 'react-native';
import Colors from '@global/colors';
import { isWeb } from '@global/screens';
import { CHECK_SIZE } from '@/constants';
import Image from '@components/global/Image';
import SociollaText from '@components/sociolla/SociollaText';
import ModalHalf from '@components/modal/ModalHalf';

const ModalSelectBox = (props) => {
  const [checked, setChecked] = useState('');
  const labelKey = props.labelKey ? props.labelKey : '';
  const options = props.options && props.options.length ? props.options : [];

  const checkValue = (value, key) =>
    typeof value == 'object' && key ? value[key] : value;

  const OptionItem = ({ item, index }) => {
    return (
      <TouchableOpacity
        activeOpacity={0.6}
        style={{
          width: '100%',
          paddingHorizontal: 15,
          paddingVertical: isWeb ? 13 : 17,
          borderBottomWidth: 1,
          borderBottomColor:
            index == (options || []).length - 1 ? 'transparent' : Colors.grey0,
          flexDirection: 'row',
          alignItems: 'center',
        }}
        onPress={async () => {
          await setChecked(item);
          props.onChange(item);
        }}>
        <View
          style={{
            width: CHECK_SIZE.width + 1,
            height: CHECK_SIZE.width + 1,
            borderRadius: CHECK_SIZE.width + 1,
            borderColor: Colors.grey0,
            borderWidth: 1,
            marginRight: 15,
          }}>
          {checkValue(checked, labelKey) == checkValue(item, labelKey) ? (
            <Image
              style={CHECK_SIZE}
              width={CHECK_SIZE.width}
              height={CHECK_SIZE.height}
              svg={true}
              source={require('@assets/img/icons/check-circle-blue.svg')}
            />
          ) : (
            false
          )}
        </View>
        <SociollaText>{labelKey ? item[labelKey] : item}</SociollaText>
      </TouchableOpacity>
    );
  };

  return (
    <ModalHalf
      testID={props.testID}
      title={props.title}
      visible={props.show}
      onClose={props.onClose}
      maxWidth={isWeb ? 450 : '100%'}
      spaceFromTop={isWeb ? '10%' : false}
      headerBordered={true}
      children={
        <>
          {options.map((item, idx) => (
            <OptionItem key={idx} index={idx} item={item} />
          ))}
        </>
      }
    />
  );
};

export default React.memo(ModalSelectBox, (prev, next) => prev == next);
